// Central Fancy Plants site + business configuration.
// Fields marked TODO must be filled with real details before launch — they are
// referenced by SEO, the footer, and structured data, so update them in one place.

export const SITE = {
  name: "Fancy Plants",
  tagline: "Exotic plants for the Irish climate",
  description:
    "A small, characterful shop for exotic and unusual plants chosen to thrive in the Irish climate — packed with care to arrive healthy.",

  // Canonical production origin (no trailing slash). Update if the live domain changes.
  url: "https://fancyplants.ie",

  // 1200x630 social share image. TODO: replace with a branded Fancy Plants cover
  // (e.g. /images/og-cover.jpg) once you have one.
  ogImage:
    "https://images.unsplash.com/photo-1525498128493-380d1990a112?auto=format&fit=crop&w=1200&h=630&q=70",

  // Contact + business details. TODO: confirm/replace remaining launch details.
  email: "hello@fancyplants.ie", // must be a real inbox AND a verified SendGrid sender
  phone: "083 818 7238", // leave "" to hide it everywhere
  phoneInternational: "+353 83 818 7238",
  location: {
    label: "Derrinboy, Kilcormac, Co. Offaly",
    streetAddress: "Derrinboy",
    locality: "Kilcormac",
    region: "Co. Offaly",
    country: "IE",
    map: {
      lat: 53.1474639,
      lon: -7.7113652,
      bbox: [-7.756, 53.125, -7.652, 53.19],
    },
  },
  vatNumber: "", // Irish VAT number, if VAT-registered
  croNumber: "", // CRO company number, if a registered company

  // Full profile URLs (leave "" to hide that icon). TODO.
  social: {
    instagram: "",
    facebook: "",
  },
};

const origin = SITE.url.replace(/\/$/, "");

// Resolve a path or relative asset to an absolute URL on the canonical origin.
export const abs = (path = "") =>
  /^https?:\/\//.test(path) ? path : origin + (path.startsWith("/") ? path : `/${path}`);

// Site-wide store structured data (JSON-LD).
export const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Store",
  name: SITE.name,
  description: SITE.description,
  url: origin,
  image: SITE.ogImage,
  ...(SITE.email ? { email: SITE.email } : {}),
  ...(SITE.phone ? { telephone: SITE.phoneInternational || SITE.phone } : {}),
  address: {
    "@type": "PostalAddress",
    ...(SITE.location.streetAddress ? { streetAddress: SITE.location.streetAddress } : {}),
    addressLocality: SITE.location.locality,
    addressRegion: SITE.location.region,
    addressCountry: SITE.location.country,
  },
  areaServed: "IE",
  sameAs: Object.values(SITE.social).filter(Boolean),
};

export const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE.name,
  url: origin,
};
